import { ProductListItemModel } from '../product/types';
import { InsuranceDocumentListItemModel } from '../../models/insurance-document-model';
import { DateTime } from 'luxon';
import { Action } from '../view/types';
import { AccountMoveLightModel, AccountMoveModel } from '../accounting/types';

export const chequeRemittanceFeatureKey = 'chequeRemittance';

export type ChequeRemittanceModel = {
  id: number;
  name: string;
  salesTeamAccountId: number;
  salesTeamAccountName: string;
  bankAccountId: number;
  bankAccountIban: string;
  amount: number;
  creationDate: DateTime;
  deliveryDate: DateTime;
  createdBySalesPersonId: number;
  createdBySalesPersonName: string;
  accountMoves: AccountMoveModel[];
  accountMovesCount: number;
  accountMoveIds: number[];
  actions: Action[];
};
